import { useGraphqlQuery } from "@harea/component"
import { TTimeOff } from "@harea/component"
import { TimeOffQuery } from "queries/TimeOffQuery"

export const useTimeOffQuery = (id?:number,suspense?:boolean, enabled?: boolean)=>{
    return useGraphqlQuery<TimeOffQuery,TTimeOff>(new TimeOffQuery({ id }), { enabled: enabled !== false && id !== undefined, suspense })
}